import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: fit-content;
  justify-content: center;
`

export const FileInput = styled.input`
  display: none;
`

export const ProgressContainer = styled.div`
    margin-top: 0.3rem;
    width: 12.2rem;
    height: 0.25rem;
    background-color: #696969;
`

export const ProgressFill = styled.div<{progress: string}>`
    width: ${props => props.progress}%;
    height: 0.25rem;
    background-color: #6ec1e4;
`

export const FileInputDiv = styled.div`
    display: flex;
    flex-direction: column;
    width: 80%;
    margin-top: 0.6rem;
    border: dashed #33A6DC 2px;
    border-radius: 0.6rem;
    background-color: #E6F4FB;
    justify-content: center;
    align-items: center;
    padding: .8rem;
`

export const FileInputLabel = styled.label`
    font-family: 'Inter', sans-serif;
    font-weight: 700;
    font-size: 1vw;
    font-size: 1rem;
    max-width: 6.8rem;
    padding-top: 0.8rem;
    padding-right: 1.1rem;
    padding-bottom: 0.7rem;
    padding-left: 1.3rem;
    background-color: #fff;
    color: #0090D3;
    border: 1px solid #0090D3;
    border-radius: 1.5rem;
    cursor: pointer;
`

export const FileInfoDiv = styled.div`
    display: flex;
    width: 18vw;
    min-height: 5vh;
    border: 1px solid #000;
`

export const FileInfoImg = styled.img`
    width: 1.5rem;
`

export const FileMiddleDiv = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 0.4rem;
    width: 12.5rem;
`

export const FileUpperMiddleDiv = styled.div`
    display: flex;
    max-height: 1.4rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 12.4rem;
    justify-content: space-between;
`

export const FileName = styled.p`
    display: block;
    margin-top: 0;
    margin-bottom: 0;
    font-size: 0.7rem;
    max-width: 10rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-family: 'Inter', sans-serif;
`

export const FilePercentage = styled.p`
    position: relative;
    margin-top: 0;
    margin-bottom: 0;
    font-size: 0.8vw;
    font-family: 'Inter', sans-serif;
`

export const FileInfoCancelImg = styled.img`
    width: 1.6vw;
`

export const FileFirstText = styled.p`
    font-size: 1rem;
    margin-top: 0.9rem;
    margin-bottom: 0;
    font-family: 'Inter', sans-serif;
`

export const FileSecondText = styled.p`
    color: #696969;
    font-size: 0.9rem;
    margin-top: 0.23rem;
    margin-bottom: 0.9rem;
    font-family: 'Inter', sans-serif;
`
